import { SET_DELIVERY_INFO, SET_LOADING, SET_ERROR } from "./actionTypes";

const serverUrl = process.env.REACT_APP_SERVER_URL;

export const setDeliveryInfo = (deliveryInfo) => ({
  type: SET_DELIVERY_INFO,
  payload: deliveryInfo,
});

export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: isLoading,
});

export const setError = (error) => ({
  type: SET_ERROR,
  payload: error,
});

// Thunk action to fetch delivery info
export const fetchDeliveryInfo = (userId) => {
  return async (dispatch) => {
    if (!userId) return;

    dispatch(setLoading(true));

    try {
      const response = await fetch(
        `${serverUrl}/users-delivery-infor?user_id=${userId}`
      );

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const data = await response.json();
      dispatch(setDeliveryInfo(data.delivery_info || {}));
    } catch (error) {
      console.error("Error fetching delivery info:", error);
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoading(false));
    }
  };
};
